import {
  Criterion,
  FieldChoice,
  ListValueType,
  CriterionListItem,
} from 'queries';
import { ParticipantField, ParticipantFieldType } from '@app/api';
import { KeywordCriterionHandler } from './KeywordCriterionHandler';

export class LocaleCriterionHandler extends KeywordCriterionHandler {
  handleCriterion(criterion: Criterion) {
    return criterion.listValueType === ListValueType.LOCALE;
  }

  criterionHandleOthers() {
    return true;
  }

  handleParticipantField(field: ParticipantField): boolean {
    return [ParticipantFieldType.LOCALES].includes(field.type);
  }

  createEmptyCriterionFromParticipantField(field: ParticipantField): Criterion {
    return {
      ...super.createEmptyCriterionFromParticipantField(field),
      listValueType: ListValueType.LOCALE,
    };
  }

  compareValues(item: CriterionListItem, choice: FieldChoice) {
    if (typeof item !== 'string') {
      return false;
    }

    if (item === choice.ref) {
      return true;
    }

    return choice.ref.toLowerCase().startsWith(item.toLowerCase());
  }
}
